import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';

import Button from '@/components/Button';
import usePageTitle from '@/hooks/usePageTitle';

const NotFoundPage = () => {
  usePageTitle('404 - Página no encontrada');
  const navigate = useNavigate();
  const theme = useTheme();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xxs: '6rem', sm: '8rem', md: '10rem' },
          fontWeight: 700,
          color: theme.palette.primary.main,
          marginBottom: theme.spacing(2),
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xxs: '1.5rem', sm: '2rem' },
          fontWeight: 600,
          color: theme.palette.text.primary,
          marginBottom: theme.spacing(2),
        }}
      >
        Página no encontrada
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: { xxs: '1rem', sm: '1.125rem' },
          color: theme.palette.text.secondary,
          marginBottom: theme.spacing(4),
          maxWidth: '600px',
        }}
      >
        Lo sentimos, la página que estás buscando no existe o ha sido movida.
      </Typography>
      <Button variant="contained" size="large" onClick={handleGoHome}>
        Volver al inicio
      </Button>
    </Box>
  );
};

export default NotFoundPage;
